module.exports = __webpack_public_path__ + "img/2004_1.c62d6820.jpg";